<template>
  <div class="auth_page">
    <div class="auth_logo">
      <img :src="merchantInfo.merchantLogo" :alt="merchantInfo.merchantName" referrerpolicy="no-referrer" />
    </div>
    <div class="auth_desc" :class="[$store.state.isMirroring && 'mirror']">
      <i18n path="authorize.requirement" tag="span">
        <span class="auth_merchant_name">{{ merchantInfo.merchantName }}</span>
        <span v-if="isLogin">
          &nbsp;(
          {{ $t('account.account') }}:
          <span style="direction: ltr">{{ formatAccount(account) }}</span>
          )
        </span>
      </i18n>
    </div>
    <div v-if="isLogin && showQuickLogin" class="check_login">
      <van-checkbox v-model="agreeQuickLogin" icon-size="12px" checked-color="#3fbb70">
        {{ $t('authorize.enableQuickLogin') }}
      </van-checkbox>
    </div>
    <van-button v-if="isLogin && !accountBanned" class="auth_btn" @click="authorize" :loading="loading">
      {{ $t('authorize.authorize') }}
    </van-button>
    <div v-if="isLogin" class="auth_text" @click="switchAccount">
      {{ $t('authorize.switchAccount') }}
    </div>
    <div v-else style="display: flex; align-items: center; justify-content: center; width: 100%">
      <router-link :to="{ name: 'beforeLogin' }" style="width: 100%; flex: 1; margin-inline-end: 0.2rem">
        <div class="auth_to_login">
          {{ $t('authorize.goToMetWallet') }}
        </div>
      </router-link>
    </div>
    <CommonDialog
      v-model="showAuthorizeErrorDialog"
      :title="$t('common.attention')"
      :content="authorizeErrorReason"
      :confirm-text="$t('common.confirm')"
      @confirm="showAuthorizeErrorDialog = false"
    />
  </div>
</template>

<script>
import CheckBox from '@/components/CheckBox'
import CommonDialog from '@/components/CommonDialog'
import { postReportLog } from '../utils/log'
export default {
  name: 'Authorize',
  data() {
    return {
      url: window.location.href,
      merchantInfo: {
        merchantName: '',
        merchantLogo: ''
      },
      loading: false,
      agreeQuickLogin: true,
      showQuickLogin: true,
      showAuthorizeErrorDialog: false,
      authorizeErrorReason: '',
      accountBanned: false
    }
  },
  components: {
    CheckBox,
    CommonDialog
  },
  computed: {
    isLogin() {
      return (
        this.$store.state.userInfo &&
        this.$store.state.userInfo.hasOwnProperty('userId') &&
        localStorage.getItem('token')
      )
    },
    account() {
      if (this.$store.state.userInfo.phone) {
        return this.$store.state.userInfo.phone ? '+' + this.$store.state.userInfo.phone : ''
      } else {
        return this.$store.state.userInfo.email
      }
    }
  },
  methods: {
    switchAccount() {
      localStorage.removeItem('apptype')
      localStorage.removeItem('token')
      this.$store.commit('delUserInfo')
      location.reload()
    },
    getMerchantInfo() {
      if (this.$route.query.hasOwnProperty('appId') && this.$route.query.hasOwnProperty('redirectUrl')) {
        const appId = this.$route.query.appId
        const urlParams = new URLSearchParams(new URL(window.location.href).search)
        const apptype =
          urlParams.get('apptype') instanceof Array ? urlParams.get('apptype')[0] : urlParams.get('apptype')
        let url = window.serverPath + `/api/merchant/info?appId=${appId}&apptype=${apptype}`

        if (apptype && apptype === '37') {
          // 针对 And 包，做特殊的逻辑处理，公用一个应用id
          url = url + '&type=1'
        } else {
          url = url + '&type=0'
        }

        this.$http
          .get(url)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              this.merchantInfo = res.data.data
            }
          })
          .catch((err) => console.log(err))
      } else {
        this.$router.replace({
          name: 'Home'
        })
      }
    },
    authorize() {
      if (this.$route.query.hasOwnProperty('appId') && this.$route.query.hasOwnProperty('redirectUrl')) {
        this.loading = true
        const appId = this.$route.query.appId
        const urlParams = new URLSearchParams(new URL(window.location.href).search)
        let apptype = urlParams.get('apptype') instanceof Array ? urlParams.get('apptype')[0] : urlParams.get('apptype')
        if (!apptype) {
          apptype = '0'
        }
        const redirectUrl = this.$route.query.redirectUrl
        const uid = encodeURIComponent(this.$route.query.uid)
        let url =
          window.serverPath +
          `/api/auth/authorize?appId=${appId}` +
          `&apptype=${apptype}` +
          `&redirectUrl=${redirectUrl}`
        if (uid && this.showQuickLogin) {
          url =
            window.serverPath +
            `/api/auth/authorize?appId=${appId}` +
            `&apptype=${apptype}` +
            `&uid=${uid}` +
            `&redirectUrl=${redirectUrl}`
        } else {
          this.agreeQuickLogin = false
        }
        this.$http
          .get(url)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              // 绑定钱包流程埋点 - step6 授权成功
              const userInfo = this.$store.state.userInfo || {}
              postReportLog({
                log_id: '477',
                extra: {
                  step: '6',
                  bind_type: userInfo.phone ? 'phone' : 'email', // 绑定方式
                  bind_account: userInfo.phone || userInfo.email || '' // 绑定邮件/电话号码
                }
              })
              const code = res.data.data.code
              const query = { ...this.$route.query }
              delete query.appId
              delete query.redirectUrl
              query.code = code
              let queryStr = ''
              for (let key in query) {
                queryStr += key + '=' + query[key] + '&'
              }
              queryStr = queryStr.substr(0, queryStr.length - 1)
              if (apptype === '36') {
                this.$http
                  .get(redirectUrl + '?' + queryStr + `&quickLoginFlag=${this.agreeQuickLogin ? 1 : 0}`)
                  .then(() => {
                    window.close()
                  })
              } else {
                window.location.href = redirectUrl + '?' + queryStr + `&quickLoginFlag=${this.agreeQuickLogin ? 1 : 0}`
              }
            } else if (res.data.code === '100020' || res.data.code === '100021') {
              this.loading = false
              this.authorizeErrorReason = res.data.message
              this.accountBanned = true
              this.showAuthorizeErrorDialog = true
            }
            setTimeout(() => {
              this.loading = false
            }, 30000)
          })
          .catch((err) => {
            console.log(err)
            setTimeout(() => {
              this.loading = false
            }, 30000)
          })
      } else {
        console.log('err')
      }
    },
    formatAccount(account) {
      if (account) {
        const len = account.length
        if (len > 10) {
          return account.substr(0, 6) + '****' + account.substr(len - 4, len)
        } else if (len > 6) {
          return account.substr(0, 4) + '***' + account.substr(len - 2, len)
        }
        return account
      }
      return account
    }
  },
  mounted() {
    // 因为此次将登录状态的判断提前，所以会偶现这里登录状态检查不到的情况，因此这里做500ms的延时来保证登录状态检查正常
    setTimeout(() => {
      if (!this.isLogin) {
        // 授权重定向信息放到sessionStorage中，解决一些情况下store中数据丢失的问题
        sessionStorage.setItem('redirectInfo', window.location.pathname + window.location.search)
        this.$router.replace('/before-login')
      } else {
        this.getMerchantInfo()
        // 获取url中的参数
        const urlParams = new URLSearchParams(new URL(window.location.href).search)
        if (urlParams.get('from') === 'agent') {
          this.showQuickLogin = false
        }
      }
    }, 500)
  },
  activated() {
    // 获取url中的参数
    const urlParams = new URLSearchParams(new URL(window.location.href).search)
    if (urlParams.get('from') === 'agent') {
      this.showQuickLogin = false
    }
  }
}
</script>

<style scoped>
.auth_page {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0.24rem;
}

.check_login {
  margin-top: 0.03rem;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  color: #443956;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.auth_logo {
  width: 0.8rem;
  height: 0.8rem;
  overflow: hidden;
  margin: 1rem 0.24rem 0.24rem;
  font-size: 0.24rem;
  line-height: 0.8rem;
}

.auth_logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  user-select: none;
}

.auth_desc {
  color: #443956;
  font-size: 0.14rem;
  text-align: left;
  line-height: 0.22rem;
  word-break: break-word;
  font-family: 'PingFang SC';
}

.auth_desc.mirror {
  text-align: right;
}

.auth_merchant_name {
  color: #3fbb70;
}

.auth_btn {
  height: 0.5rem;
  padding: 0.13rem 0;
  font-size: 0.18rem;
  font-weight: bold;
  background: #3fbb70;
  margin: 0.3rem 0 0;
  width: 100%;
  border-radius: 0.12rem;
  line-height: 0.24rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  user-select: none;
}

.auth_text {
  height: 0.5rem;
  font-size: 0.16rem;
  font-weight: bold;
  margin: 0.12rem 0 0.24rem;
  width: 100%;
  border-radius: 0.12rem;
  border: 0.01rem solid #3fbb70;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3fbb70;
  user-select: none;
}

.auth_to_login {
  height: 0.42rem;
  font-size: 0.18rem;
  font-weight: bold;
  width: 100%;
  border-radius: 0.06rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3fbb70;
  border: 2px solid #3fbb70;
  user-select: none;
  margin: 0.3rem 0 0.24rem;
}

.auth_to_register {
  height: 0.42rem;
  font-size: 0.18rem;
  font-weight: bold;
  width: 100%;
  border-radius: 0.06rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3fbb70;
  border: 2px solid #3fbb70;
  user-select: none;
  margin: 0.3rem 0 0.24rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Authorize.vue